import React, { Component } from "react";
import ErrorBoundaryFallbackComponent from "./ErrorBoundaryFallbackComponent";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true, error: error, info: info });
  }

  render() {
    const { children } = this.props;
    const { hasError, error, info } = this.state;

    if (hasError) {
      return <ErrorBoundaryFallbackComponent error={error} info={info} />;
    }

    return children || null;
  }
}

export const withErrorBoundary = Component => {
  const Wrapped = props => (
    <ErrorBoundary>
      <Component {...props} />
    </ErrorBoundary>
  );

  return Wrapped;
};

export default ErrorBoundary;
